import { TOKEN_KEY, USER_KEY } from 'constants/keys'
import { useCallback, useEffect, useState } from 'react'
import api from 'services/api'
import { IUser } from 'types/user'

const useAuthentication = () => {
  const [token, setToken] = useState<string>(() => localStorage.getItem(TOKEN_KEY) || '')
  const [user, setUser] = useState<IUser | null>(() => {
    const storedUser = localStorage.getItem(USER_KEY)

    return storedUser ? JSON.parse(storedUser) : null
  })

  const updateToken = useCallback((newToken: string) => {
    setToken(newToken)
    localStorage.setItem(TOKEN_KEY, newToken)
    api.defaults.headers.common['Authorization'] = `Bearer ${newToken}`
  }, [])

  const updateUser = useCallback((newUser: IUser) => {
    setUser(newUser)
    localStorage.setItem(USER_KEY, JSON.stringify(newUser))
  }, [])

  const updateUserWithStorage = useCallback(
    (newUser: IUser) => {
      // Preserva skipUpload se já estiver true no localStorage
      const storedUser = localStorage.getItem(USER_KEY)
      const currentSkipUpload = storedUser ? JSON.parse(storedUser).skipUpload : false

      newUser.skipUpload = currentSkipUpload || false

      setUser((prev) => ({
        ...prev,
        ...newUser,
      }))

      updateUser(newUser)
    },
    [updateUser, setUser]
  )

  const clearStorage = useCallback(() => {
    setToken('')
    setUser(null)
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_KEY)
    delete api.defaults.headers.common['Authorization']
  }, [])

  useEffect(() => {
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`
    } else {
      delete api.defaults.headers.common['Authorization']
    }
  }, [token])

  return {
    token,
    user,
    updateToken,
    updateUser,
    updateUserWithStorage,
    clearStorage,
  }
}

export default useAuthentication
